import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'

import * as R from 'ramda'

import MenuItem from 'material-ui/MenuItem';

import Combobox from 'components/Combobox'

import dataActions from 'actions/dataActions'

import { doc, dirtyRead } from '../selectors/common'
import { tenants } from '../selectors/entities'

import { sortSev } from 'utils/stuff'

let select = dirtyRead(
	(state, props) => ({
		object: doc(state, props.objectID)
	  , tenants: tenants(state)
	})
)

export class TenantCombobox extends Component{
	render(){
		let { props } = this
		let tenantID = props.object && (props.object.tenant || props.object.tenantID)
		return(
			<Combobox
				icon={
					<img
						src={'/' + process.env.REACT_APP_NAME + "/static/img/svg-icon/tenants_green.svg"}
						className="left-navigation-icons"
						style={{
							height: "19px"
						  , position: "relative"
						  , top: "0px"
						  , left: "-2px"
						  , display: ""
						}}
					/>
				}
				link={`/manager/tenant/${tenantID}/`}
				text={(tenantID && props.tenants[tenantID])? `${props.tenants[tenantID].tenant || props.tenants[tenantID].firstName + ' ' + props.tenants[tenantID].lastName}`: ''}
				hintText={<span>Enter tenant name</span>}
				dataSource={
					R.map(tenant => ({
						text: `${tenant.tenant || tenant.firstName + " " + tenant.lastName}`
					  , value: (<MenuItem key={tenant._id} primaryText={`${tenant.tenant || tenant.firstName + " " + tenant.lastName}`}/>)
					  , id: tenant._id
					}), sortSev(props.tenants, "firstName", "lastName"))
				}
				onChange={(tenant)=> {
					props.STAGE({
						_id: props.objectID
					  , tenantID: tenant && tenant.id
					})
				}}
			/>
		)
	}
}

export default connect(select, dataActions)(TenantCombobox)



// WEBPACK FOOTER //
// ./src/components/TenantCombobox.js